// src/locales/si/callCenterCommission.js
export const callCenterCommission = {
  pageTitle: 'හරස්-විකුණුම් කොමිසම',
  pageDescription: 'මාස අවසාන හරස්-විකුණුම් කොමිසම අවසන් කර පෙර කොමිස් ධාවන පරීක්ෂා කරන්න',
  failedToLoadCommissions: 'කොමිස් වාර්තා පූරණය කිරීමට අසමත් විය',
  finalizeLastMonth: 'පසුගිය මාසය අවසන් කරන්න',
  finalize: 'අවසන් කරන්න',
  finalizeConfirmMessage: 'මෙය {month} සඳහා හරස්-විකුණුම් කොමිසම අවසන් කර නැවත වෙනස් කළ නොහැක. ඉදිරියට යන්නද?',
  finalizeSuccess: 'කොමිසම සාර්ථකව අවසන් කරන ලදී',
  finalizeFailed: 'කොමිසම අවසන් කිරීමට අසමත් විය',
  filterByMonth: 'මාසය',
  allMonths: 'සියලුම මාස',
  settlementMonth: 'පියවීම් මාසය',
  totalCommission: 'මුළු කොමිසම',
  status: {
    pending: 'සමාලෝචනය පොරොත්තුවෙන්',
    completed: 'සම්පූර්ණයි',
  },
  finalizedAt: 'අවසන් කළ දිනය',
  noCommissionsYet: 'තවම කොමිස් වාර්තා නැත',
  noCommissionsYetDescription: 'පළමු කොමිස් වාර්තාව සෑදීමට පසුගිය මාසය අවසන් කරන්න',
  detailsPageTitle: 'කොමිසම විස්තර',
  detailsPageDescription: 'මෙම පියවීම් මාසය සඳහා කාර්ය මණ්ඩල හරස්-විකුණුම් කොමිස් බෙදීම',
  failedToLoadCommission: 'කොමිස් වාර්තාව පූරණය කිරීමට අසමත් විය',
  markCompleted: 'සම්පූර්ණ ලෙස සලකුණු කරන්න',
  completeConfirmMessage: 'මෙම කොමිසම සම්පූර්ණ ලෙස සලකුණු කරන්නද? මෙය නැවත වෙනස් කළ නොහැක.',
  completeSuccess: 'කොමිසම සම්පූර්ණ ලෙස සලකුණු කරන ලදී',
  completeFailed: 'කොමිසම සම්පූර්ණ ලෙස සලකුණු කිරීමට අසමත් විය',
  finalizeMonth: 'මාසය අවසන් කරන්න',
  selectMonthToFinalize: 'අවසන් කිරීමට මාසය තෝරන්න',
  reverse: 'අවසන් කිරීම ආපසු හරවන්න',
  reverseConfirmMessage: 'මෙය {month} සඳහා අවසන් කළ කොමිසම ආපසු හරවා එහි කොමිසම් වාර්තා ස්ථිරවම මකා දමයි. ඉදිරියට යන්නද?',
  reverseSuccess: 'කොමිසම අවසන් කිරීම සාර්ථකව ආපසු හරවන ලදී',
  reverseFailed: 'කොමිසම අවසන් කිරීම ආපසු හැරවීමට අසමත් විය',
  staffMember: 'කාර්ය මණ්ඩල සාමාජිකයා',
  userId: 'පරිශීලක හැඳුනුම්පත',
  commissionAmount: 'කොමිස් ප්‍රමාණය',
  finalizedBy: 'අවසන් කළේ',
  noStaffCommissionRecords: 'කාර්ය මණ්ඩල කොමිස් වාර්තා හමු නොවීය',
  staffPageTitle: 'හරස්-විකුණුම් කාර්ය මණ්ඩල කොමිසම',
  staffPageDescription: 'ලබා දුන් මාසයක් සඳහා මුරයක් අනුව ලබාගත් හරස්-විකුණුම් කොමිසම බලන්න',
  failedToLoadStaffReport: 'කාර්ය මණ්ඩල කොමිස් වාර්තාව පූරණය කිරීමට අසමත් විය',
  filterByUser: 'කාර්ය මණ්ඩල සාමාජිකයා',
  allUsers: 'සියලුම කාර්ය මණ්ඩලය',
  estimate: 'ඇස්තමේන්තුව',
  excelButtonLabel: 'Excel',
};
